/* eslint-disable @next/next/no-sync-scripts */
import React, { useEffect } from 'react'
import { store } from '@/store/store'
import { Provider } from 'react-redux'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Layout from '@/components/Layout'
import Header from '@/components/common/Head'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '@/styles/globals.scss'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from '@/utils/authConfig'
import { withLDProvider } from 'launchdarkly-react-client-sdk'
import { HubspotProvider } from 'next-hubspot'

export const ChatContext = React.createContext()

function MyApp({ Component, pageProps }) {
  const queryClient = new QueryClient()

  useEffect(() => {
    const handler = (event) => {
      if (event.key === 'logout-event' && event.newValue === 'started') {
        msalInstance.logoutRedirect({
          onRedirectNavigate: () => false,
        })
        window.location.reload()
      }
      if (event.key === 'login-event' && event.newValue === 'started') {
        msalInstance.loginRedirect({
          onRedirectNavigate: () => false,
        })
        window.location.reload()
      }
    }
    window.addEventListener('storage', handler)
    return () => {
      window.removeEventListener('storage', handler)
    }
  }, [])

  return (
    <Provider store={store}>
      {/* SEO head: pageProps.seo (from a page's getServerSideProps) gives the
          correct per-page tags, server-rendered. */}
      <Header seo={pageProps?.seo} />
      <QueryClientProvider client={queryClient}>
        <MsalProvider instance={msalInstance}>
          <HubspotProvider>
            <Layout>
              <Component {...pageProps} />
            </Layout>
          </HubspotProvider>
        </MsalProvider>
      </QueryClientProvider>
    </Provider>
  )
}

export default withLDProvider({
  clientSideID: '65001457985fe9125d41b38e',
})(MyApp)
